import * as React from 'react'
import * as styles from './style/index.scss'
import intl from '@utils/intl';

export default class EmptyCard extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <>
                <div className={styles.container}>
                    {/*<h2>{intl.formatMessage({id: `empty.card.shop`})}</h2>*/}
                    <h2>go shop</h2>
                </div>
            </>
        )
    }
}
